module.exports = __webpack_public_path__ + "static/gira-sans-bold-b6e3ad63779379be1228723871d144f7.woff";